import Link from 'next/link'
import styles from '../../ListPage.module.scss'
import SearchTagList from 'components/cases/listpage/common/SearchTagList'
import Button from 'components/commons/Button/Button'
import { useEffect, useRef, useState } from 'react'
import { gsap, Power4 } from 'gsap'

interface AccordionNavProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  categoryTitle: string
}

const AccordionNav: React.FC<AccordionNavProps> = ({ isOpen, setIsOpen, categoryTitle }) => {
  const navRef = useRef<HTMLDivElement>(null)
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 720)
    }

    // Initial check
    handleResize()

    // Listen for resize events
    window.addEventListener('resize', handleResize)

    // Clean up event listener on unmount
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    gsap.to(navRef.current, {
      opacity: 1,
      y: 0,
      duration: 0.6,
      ease: Power4.easeOut,
      scrollTrigger: {
        trigger: navRef.current,
        start: 'top 80%',
        toggleActions: 'play none none reverse',
      },
    })
  }, [])

  return (
    <>
      <button
        className={`${styles.postContent_accordion} ${styles.accordionBtn} ${isOpen ? styles.isOpen : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>サービスから探す</span>
      </button>

      <div
        ref={navRef}
        className={`${styles.postContent_nav} ${styles.accordionBody}`}
        aria-hidden={!isOpen}
        style={isMobile ? { maxHeight: isOpen ? '9999px' : '0' } : {}}
      >
        <div className={styles.allbtn}>
          <Link href="/cases">すべてのサービス・業界</Link>
        </div>
        <SearchTagList currentCategory={categoryTitle} />
        <div className={styles.contactPanel}>
          <p className={styles.contactPanel_ttl}>Contact</p>
          <p className={styles.contactPanel_desc}>
            <span>お気軽にお問い合わ</span>
            <span>せください</span>
          </p>
          <div className={styles.contactPanel_btn}>
            <Button text="お問い合わせ" href="/contact" red="red" />
          </div>
        </div>
      </div>
    </>
  )
}

export default AccordionNav
